const ba_api = process.env.BA_API;

export default {
  api: ba_api,
  services: {
    companies: ba_api + "/companies",
    billing: ba_api + "/billing",
    companyHouse: ba_api + "/companies/companyHouse",
    companyDetails: ba_api + "/companies/getCompanyDetails",
    properties: ba_api + "/properties",
    portals: ba_api + "/portals",
    portalsCustom: ba_api + "/portals-custom",
    gdpr: ba_api + "/gdpr",
    applicants: ba_api + "/applicants",
    website: ba_api + "/wp",
    domains: ba_api + "/domains",
    suppliers: ba_api + "/suppliers"
  },
  aws: {
    region: "eu-west-2",
    bucket: "bestagent",
    identityPoolId: process.env.BA_IDENTITYPOOLID,
    userPoolId: process.env.BA_USERPOOLID,
    userPoolClientId: process.env.BA_USERPOOLCLIENTID
  },
  social: {
    fbAppId: "1914621552188664",
    googleAppId:
      "446207093208-enjtcbiub6tf3t9o79kofgiaglk9c9u0.apps.googleusercontent.com",
    linkedinId: "78dyng07s6xrbc",
    linkedinIdSecret: "w104AJpWr4f99wQA"
  }
};
